'use client';

import dynamic from 'next/dynamic';
import { useParams } from 'next/navigation';
import PageHeader from '@/components/common/PageHeader';

const DynamicComponent3WithNoSSR = dynamic(() => import('../../../components/ECommerceTour'), {
  ssr: false,
});

const getParams = (slug: string | string[]) => {
  let matterId;
  let videoType;
  let rule;
  let room;
  let renderType = 2;
  // renderType
  // 0 : /e-commerce-tour/:mattterId
  // 1 : /token/:token
  // 2 : /e-commerce-tour/:slug/:videoType/:rule/:chatToken

  if (
    slug.length === 1 ||
    (slug.length > 1 && slug[1] === 'processOrder') ||
    (slug.length > 1 && slug[1] === 'book') ||
    (slug.length > 1 && slug[1] === 'login')
  ) {
    matterId = slug[0];
    renderType = 0;
  } else if (slug.length === 4) {
    matterId = slug[0];
    videoType = slug[1];
    rule = slug[2];
    room = slug[3];
    renderType = 2;
    // eslint-disable-next-line no-console
  } else console.log('Wrong url, ask Boaz how to behave');
  return {
    matterId,
    videoType,
    rule,
    room,
    renderType,
  };
};

type Props = {
  data: string;
  slug: string[];
};

export default function ECommerceTourPageClient({ data, slug }: Props) {
  const {
    title,
    description,
    tourImage,
    website,
    fbPixel,
    fbAppId,
    faviconUrl,
    htmlCode,
    tourData,
    tags,
    matterTags,
    charset,
  } = JSON.parse(data);

  const { matterId, videoType, rule, room, renderType } = getParams(slug);

  return (
    <PageHeader
      title={title}
      description={description}
      slug={matterId}
      tourImage={tourImage}
      website={website}
      fbPixel={fbPixel}
      fbAppId={fbAppId}
      faviconUrl={faviconUrl}
      htmlCode={htmlCode}
      type="e-commerce-tour"
      charset={charset}
    >
      <DynamicComponent3WithNoSSR
        tourData={tourData}
        tags={tags}
        matterTags={matterTags}
        renderType={renderType}
        matterId={matterId}
        videoType={videoType}
        rule={rule}
        room={room}
        reactAws={process.env.NEXT_PUBLIC_CDN}
        reactAppDomain={process.env.NEXT_PUBLIC_API}
        reactAppMatterPort={process.env.NEXT_PUBLIC_MP_SDK_KEY}
        reactPaypalClient={process.env.NEXT_PUBLIC_PAYPAL_CLIENT}
      />
    </PageHeader>
  );
}
